<template>
  <div v-if="initPage">
    <div v-loading="true" class="loading"></div>
  </div>
  <div v-else>
    <el-row type="flex" justify="space-between">
      <el-col :span="6">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" class="grid-container-left">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :columnDefs="reportingMonthColumnDefs"
              :rowData="reportingMonth"
              :defaultColDef="defaultColDef"
              :gridOptions="reportingMonthGridOptions"
              :modules="agGridModules"
              @grid-ready="onReportingMonthGridReady"
              @first-data-rendered="onReportingMonthFirstDataRendered"
              @gridSizeChanged="onGridSizeChanged"
              @modelUpdated="onReportingMonthModelUpdated"
              @rowSelected="onReportingMonthRowSelected"
              @cellContextMenu="onReportingMonthRowRightClicked"
            ></ag-grid-vue>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24" class="grid-container-left">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :columnDefs="paymentSenderColumnDefs"
              :rowData="paymentSender"
              :defaultColDef="defaultColDef"
              :gridOptions="paymentSenderGridOptions"
              :modules="agGridModules"
              @grid-ready="onPaymentSenderGridReady"
              @first-data-rendered="onPaymentSenderFirstDataRendered"
              @gridSizeChanged="onGridSizeChanged"
              @modelUpdated="onPaymentSenderModelUpdated"
              @rowSelected="onPaymentSenderRowSelected"
              @cellContextMenu="onPaymentSenderRowRightClicked"
            ></ag-grid-vue>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24" class="grid-container-left">
            <div class="my-card-cont">
              <div class="my-card-box">
                <span>{{ $t("controlinetpays.displayPayment.title") }}</span>
              </div>
              <div class="my-card-box">
                <el-radio-group v-model="paymentType">
                  <el-radio class="radio-vertical-block" :label="99">{{
                    $t("controlinetpays.displayPayment.payAll")
                  }}</el-radio>
                  <el-radio class="radio-vertical-block" :label="1">{{
                    $t("controlinetpays.displayPayment.payMoneyReceived")
                  }}</el-radio>
                  <el-radio class="radio-vertical-block" :label="0">{{
                    $t("controlinetpays.displayPayment.payMoneyNotReceived")
                  }}</el-radio>
                </el-radio-group>
              </div>
              <div class="my-card-box">
                <el-checkbox
                  v-model="displayPaymentsAccounts"
                  style="margin-left: 0em"
                  >{{
                    $t("controlinetpays.displayPayment.payPersonalAccounts")
                  }}</el-checkbox
                >
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="18">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" :class="classRightContainer">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :columnDefs="inetPayNotConnectedPaymentsColumnDefs"
              :rowData="inetPayNotConnectedPayments"
              :defaultColDef="defaultColDef"
              :gridOptions="inetPayNotConnectedPaymentsGridOptions"
              :modules="agGridModules"
              @grid-ready="onInetPayNotConnectedPaymentsGridReady"
              @first-data-rendered="
                onInetPayNotConnectedPaymentsFirstDataRendered
              "
              @gridSizeChanged="onGridSizeChanged"
              @modelUpdated="onInetPayNotConnectedPaymentsModelUpdated"
              @rowSelected="onInetPayNotConnectedPaymentsRowSelected"
              @cellContextMenu="onInetPayNotConnectedPaymentsRowRightClicked"
            ></ag-grid-vue>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          justify="space-between"
          v-show="displayPaymentsAccounts"
        >
          <el-col :span="24" class="grid-container-right-halfheight">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :columnDefs="personalAccountsPaymentsColumnDefs"
              :rowData="personalAccountsPayments"
              :defaultColDef="defaultColDef"
              :gridOptions="personalAccountsPaymentsGridOptions"
              :modules="agGridModules"
              :getRowStyle="getRowStyle"
              :pinnedBottomRowData="personalAccountsPaymentsBottomRowData"
              @grid-ready="onPersonalAccountsPaymentsGridReady"
              @first-data-rendered="onPersonalAccountsPaymentsFirstDataRendered"
              @gridSizeChanged="onGridSizeChanged"
              @modelUpdated="onPersonalAccountsPaymentsModelUpdated"
              @rowSelected="onPersonalAccountsPaymentsRowSelected"
              @cellContextMenu="onPersonalAccountsPaymentsRowRightClicked"
            ></ag-grid-vue>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          justify="space-between"
          style="margin-top: 10px; margin-left: 10px"
        >
          <el-col :span="24">
            <el-button
              type="primary"
              size="small"
              :disabled="moveToNextMonthBtnDisabled"
              @click="onMoveToNextMonthBtn"
              >{{ $t("common.buttons.moveToNextMonth") }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              :disabled="cancelReceivedRegistryBtnDisabled"
              @click="onCancelReceivedRegistryBtn"
              >{{ $t("common.buttons.cancelReceivedRegistry") }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-show="displayPaymentsAccounts"
              :disabled="cancelSubscriberPaymentBtnDisabled"
              @click="onCancelSubscriberPaymentBtn"
              >{{ $t("common.buttons.cancelSubscriberPayment") }}</el-button
            >
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { sortSum, formatSum, capitalizeFirstLetter } from "@/helpers/reference";
import { mapActions, mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import { AllCommunityModules } from "@ag-grid-community/all-modules";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import { $ } from "moneysafe";
import { setGridView } from "@/helpers/grid";
import { checkAccess } from "@/helpers/access";

export default {
  name: "controlinetpays",
  components: {
    AgGridVue
  },
  data() {
    return {
      agGridModules: AllCommunityModules,
      agGridlocaleText: null,
      reportingMonthGridOptions: null,
      reportingMonthGridApi: null,
      reportingMonthColumnApi: null,
      paymentSenderGridOptions: null,
      paymentSenderGridApi: null,
      paymentSenderColumnApi: null,
      inetPayNotConnectedPaymentsGridOptions: null,
      inetPayNotConnectedPaymentsGridApi: null,
      inetPayNotConnectedPaymentsColumnApi: null,
      personalAccountsPaymentsGridOptions: null,
      personalAccountsPaymentsGridApi: null,
      personalAccountsPaymentsColumnApi: null,
      personalAccountsPaymentsBottomRowData: null,
      getRowStyle: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: false,
        filterParams: {
          applyButton: false,
          clearButton: true
        },
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      reportingMonthColumnDefs: [
        {
          headerName: this.$t(
            "controlinetpays.reportingMonthColumn.headers.reportingMonth"
          ),
          headerTooltip: this.$t(
            "controlinetpays.reportingMonthColumn.headers.reportingMonth"
          ),
          field: "datebanktext",
          tooltipField: "datebanktext",
          cellClass: "reporting-month",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "MMMM YYYY").unix()) -
            parseInt(this.$moment(date2, "MMMM YYYY").unix())
        }
      ],
      paymentSenderColumnDefs: [
        {
          headerName: this.$t(
            "controlinetpays.paymentSenderColumn.headers.paymentSender"
          ),
          headerTooltip: this.$t(
            "controlinetpays.paymentSenderColumn.headers.paymentSender"
          ),
          field: "namefirme",
          tooltipField: "namefirme",
          cellClass: "payment-sender"
        }
      ],
      inetPayNotConnectedPaymentsColumnDefs: [
        {
          headerName: this.$t(
            "controlinetpays.inetPayNotConnectedPaymentsColumn.headers.inetPayNotConnectedPayments"
          ),
          headerTooltip: this.$t(
            "controlinetpays.inetPayNotConnectedPaymentsColumn.headers.inetPayNotConnectedPayments"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.datepay"),
              headerTooltip: this.$t("common.gridColumns.datepay"),
              field: "dateclient",
              tooltipField: "dateclient",
              sort: "asc",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.countpays"),
              headerTooltip: this.$t("common.gridColumns.countpays"),
              field: "countpay",
              tooltipField: "countpay",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.summpay"),
              headerTooltip: this.$t("common.gridColumns.summpay"),
              field: "summpay",
              tooltipField: "summpay",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.summtrans"),
              headerTooltip: this.$t("common.gridColumns.summtrans"),
              field: "summtrans",
              tooltipField: "summtrans",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.transferid"),
              headerTooltip: this.$t("common.gridColumns.transferid"),
              field: "transferid",
              tooltipField: "transferid",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            }
          ]
        }
      ],
      personalAccountsPaymentsColumnDefs: [
        {
          headerName: this.$t(
            "controlinetpays.personalAccountsPaymentsColumn.headers.abcodeLong"
          ),
          headerTooltip: this.$t(
            "controlinetpays.personalAccountsPaymentsColumn.headers.abcodeLong"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.abcodeLong"),
              headerTooltip: this.$t("common.gridColumns.abcodeLong"),
              field: "abcode",
              tooltipField: "abcode",
              cellClass: "reporting-month"
            },
            {
              headerName: this.$t("common.gridColumns.fio"),
              headerTooltip: this.$t("common.gridColumns.fio"),
              field: "fio",
              tooltipField: "fio",
              cellClass: "reporting-month"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summpay",
              tooltipField: "summpay",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            }
          ]
        },
        {
          headerName: this.$t(
            "controlinetpays.personalAccountsPaymentsColumn.headers.payment"
          ),
          headerTooltip: this.$t(
            "controlinetpays.personalAccountsPaymentsColumn.headers.payment"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.datebeginfact"),
              headerTooltip: this.$t("common.gridColumns.datebeginfact"),
              field: "datepay",
              tooltipField: "datepay",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.statusname"),
              headerTooltip: this.$t("common.gridColumns.statusname"),
              field: "namepay",
              tooltipField: "namepay"
            },
            {
              headerName: this.$t("common.gridColumns.payname"),
              headerTooltip: this.$t("common.gridColumns.payname"),
              field: "nameplat",
              tooltipField: "nameplat"
            }
          ]
        },
        {
          headerName: this.$t(
            "controlinetpays.personalAccountsPaymentsColumn.headers.registry"
          ),
          headerTooltip: this.$t(
            "controlinetpays.personalAccountsPaymentsColumn.headers.registry"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.datebeginfact"),
              headerTooltip: this.$t("common.gridColumns.datebeginfact"),
              field: "datedeliv",
              tooltipField: "datedeliv",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.statusname"),
              headerTooltip: this.$t("common.gridColumns.statusname"),
              field: "namedelivery",
              tooltipField: "namedelivery"
            },
            {
              headerName: this.$t("common.gridColumns.intkey"),
              headerTooltip: this.$t("common.gridColumns.intkey"),
              field: "intkey",
              tooltipField: "intkey"
            }
          ]
        }
      ],
      paymentType: 99,
      displayPaymentsAccounts: false,
      classRightContainer: "grid-container-right-fullheight",
      currentReportingMonthRowSelected: null,
      currentPaymentSenderRowSelected: null,
      currentInetPayNotConnectedPaymentsRowSelected: null,
      currentPersonalAccountsPaymentsRowSelected: null,
      moveToNextMonthBtnDisabled: true,
      cancelReceivedRegistryBtnDisabled: true,
      cancelSubscriberPaymentBtnDisabled: true
    };
  },
  computed: mapGetters([
    "reportingMonth",
    "paymentSender",
    "inetPayNotConnectedPayments",
    "personalAccountsPayments",
    "controlInetPaysReloadAllGrids",
    "controlInetPaysReloadUpDownGrids",
    "initPage",
    "params"
  ]),
  watch: {
    paymentType: function() {
      this.getInetPayNotConnectedPayments();
    },
    displayPaymentsAccounts: function(value) {
      if (value) {
        this.classRightContainer = "grid-container-right-halfheight";
        if (this.currentInetPayNotConnectedPaymentsRowSelected) {
          this.getPersonalAccountsPayments();
        }
      } else {
        this.classRightContainer = "grid-container-right-fullheight";
        this.currentPersonalAccountsPaymentsRowSelected = null;
        this.$store.commit("clearPersonalAccountsPayments");
      }
    },
    controlInetPaysReloadAllGrids: function(value) {
      if (value) {
        this.getReportingMonth();
      }
    },
    controlInetPaysReloadUpDownGrids: function(value) {
      if (value) {
        this.getInetPayNotConnectedPayments();
      }
    }
  },
  beforeCreate() {
    if (!checkAccess(77)) {
      this.$router.push("/");
    }
  },
  created() {
    document.title = this.$t("controlinetpays.title");
    this.getParams({
      gfirme: "1",
      codepay: "1",
      firstdate: "1"
    });
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.reportingMonthGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.paymentSenderGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.inetPayNotConnectedPaymentsGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.personalAccountsPaymentsGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.getRowStyle = params => {
      if (params.node.rowPinned) return { "font-weight": "bold" };
    };
  },
  beforeDestroy() {
    this.$store.commit("setParams", null);
    this.$store.commit("clearReportingMonth");
    this.$store.commit("clearPaymentSender");
    this.$store.commit("clearInetPayNotConnectedPayments");
    this.$store.commit("clearPersonalAccountsPayments");
  },
  methods: {
    ...mapActions(["getParams"]),
    onGridSizeChanged(params) {
      // params.api.sizeColumnsToFit();
    },
    onReportingMonthGridReady(params) {
      this.reportingMonthGridApi = params.api;
      this.reportingMonthColumnApi = params.columnApi;

      this.getReportingMonth();
    },
    onReportingMonthFirstDataRendered(event) {
      setGridView("wb-controlinetpays-grid-reportingmonth", event, "optimal");
    },
    onReportingMonthRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-controlinetpays-grid-reportingmonth"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onReportingMonthModelUpdated(params) {
      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
    },
    onReportingMonthRowSelected(params) {
      if (params.node.selected) {
        this.currentReportingMonthRowSelected = params.node.data;
        this.getPaymentSender();
      }
    },
    onPaymentSenderGridReady(params) {
      this.paymentSenderGridApi = params.api;
      this.paymentSenderColumnApi = params.columnApi;
    },
    onPaymentSenderFirstDataRendered(event) {
      setGridView("wb-controlinetpays-grid-paymentsender", event, "optimal");
    },
    onPaymentSenderRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-controlinetpays-grid-paymentsender"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onPaymentSenderModelUpdated(params) {
      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
    },
    onPaymentSenderRowSelected(params) {
      if (params.node.selected) {
        this.currentPaymentSenderRowSelected = params.node.data;
        this.getInetPayNotConnectedPayments();
      }
    },
    onInetPayNotConnectedPaymentsGridReady(params) {
      this.inetPayNotConnectedPaymentsGridApi = params.api;
      this.inetPayNotConnectedPaymentsColumnApi = params.columnApi;
    },
    onInetPayNotConnectedPaymentsFirstDataRendered(event) {
      setGridView("wb-controlinetpays-grid-inetpaynotconn", event, "optimal");
    },
    onInetPayNotConnectedPaymentsRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-controlinetpays-grid-inetpaynotconn"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onInetPayNotConnectedPaymentsModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();

      this.moveToNextMonthBtnDisabled = this.cancelReceivedRegistryBtnDisabled =
        rowCount === 0 ? true : false;

      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
    },
    onInetPayNotConnectedPaymentsRowSelected(params) {
      if (params.node.selected) {
        this.currentInetPayNotConnectedPaymentsRowSelected = params.node.data;

        const {
          datebank,
          transferid
        } = this.currentInetPayNotConnectedPaymentsRowSelected;

        const currentDateBank = this.$moment(datebank, "DD.MM.YYYY").format(
          "MM.YYYY"
        );
        const currentServerDate = this.$moment(
          this.params.firstdate.date,
          "DD.MM.YYYY"
        ).format("MM.YYYY");

        this.moveToNextMonthBtnDisabled =
          currentDateBank === currentServerDate ? true : false;
        this.cancelReceivedRegistryBtnDisabled =
          transferid === "" ? true : false;

        if (this.displayPaymentsAccounts) {
          this.getPersonalAccountsPayments();
        }
      }
    },
    onPersonalAccountsPaymentsGridReady(params) {
      this.personalAccountsPaymentsGridApi = params.api;
      this.personalAccountsPaymentsColumnApi = params.columnApi;
    },
    onPersonalAccountsPaymentsFirstDataRendered(event) {
      setGridView("wb-controlinetpays-grid-persaccpay", event, "optimal");
    },
    onPersonalAccountsPaymentsRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-controlinetpays-grid-persaccpay"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onPersonalAccountsPaymentsModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();

      this.cancelSubscriberPaymentBtnDisabled = rowCount === 0 ? true : false;

      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );

      let pinnedRowSummpay = 0;
      for (let i = 0; i < rowCount; i++) {
        let rowNode = params.api.getDisplayedRowAtIndex(i);
        pinnedRowSummpay = $(pinnedRowSummpay)
          .add($(rowNode.data.summpay))
          .toNumber();
      }
      pinnedRowSummpay = formatSum($(pinnedRowSummpay).toFixed());

      try {
        this.personalAccountsPaymentsBottomRowData = [
          {
            abcode: rowCount,
            fio: "",
            summpay: pinnedRowSummpay,
            datepay: "",
            namepay: "",
            datedeliv: "",
            namedelivery: "",
            intkey: ""
          }
        ];
      } catch {
        this.personalAccountsPaymentsBottomRowData = [
          {
            abcode: "0",
            fio: "",
            summpay: "0.00",
            datepay: "",
            namepay: "",
            datedeliv: "",
            namedelivery: "",
            intkey: ""
          }
        ];
      }
    },
    onPersonalAccountsPaymentsRowSelected(params) {
      if (params.node.selected) {
        this.currentPersonalAccountsPaymentsRowSelected = params.node.data;
      }
    },
    getReportingMonth() {
      this.reportingMonthGridOptions.api.setRowData([]);
      this.paymentSenderGridOptions.api.setRowData([]);
      this.inetPayNotConnectedPaymentsGridOptions.api.setRowData([]);
      this.personalAccountsPaymentsGridOptions.api.setRowData([]);

      if (this.reportingMonthGridOptions.api) {
        this.reportingMonthGridOptions.api.setRowData([]);
        this.reportingMonthGridOptions.api.showLoadingOverlay();
      }
      this.$store.dispatch("getReportingMonth");
    },
    getPaymentSender() {
      this.paymentSenderGridOptions.api.setRowData([]);
      this.inetPayNotConnectedPaymentsGridOptions.api.setRowData([]);
      this.personalAccountsPaymentsGridOptions.api.setRowData([]);

      const { datebank } = this.currentReportingMonthRowSelected;

      if (this.paymentSenderGridOptions.api) {
        this.paymentSenderGridOptions.api.setRowData([]);
        this.paymentSenderGridOptions.api.showLoadingOverlay();
      }
      this.$store.dispatch("getPaymentSender", { datebank });
    },
    getInetPayNotConnectedPayments() {
      this.inetPayNotConnectedPaymentsGridOptions.api.setRowData([]);
      this.personalAccountsPaymentsGridOptions.api.setRowData([]);

      const { datebank } = this.currentReportingMonthRowSelected;
      const { codefirme } = this.currentPaymentSenderRowSelected;
      const ptransferid = this.paymentType;

      if (this.inetPayNotConnectedPaymentsGridOptions.api) {
        this.inetPayNotConnectedPaymentsGridOptions.api.setRowData([]);
        this.inetPayNotConnectedPaymentsGridOptions.api.showLoadingOverlay();
      }
      this.$store.dispatch("getInetPayNotConnectedPayments", {
        codefirme,
        datebank,
        ptransferid
      });
    },
    getPersonalAccountsPayments() {
      this.personalAccountsPaymentsGridOptions.api.setRowData([]);

      const {
        codefirme,
        dateclient,
        npack,
        transferid
      } = this.currentInetPayNotConnectedPaymentsRowSelected;
      const ptransferid = this.paymentType;

      if (this.personalAccountsPaymentsGridOptions.api) {
        this.personalAccountsPaymentsGridOptions.api.setRowData([]);
        this.personalAccountsPaymentsGridOptions.api.showLoadingOverlay();
      }
      this.$store.dispatch("getPersonalAccountsPayments", {
        codefirme,
        dateclient,
        npack,
        transferid,
        ptransferid
      });
    },
    onMoveToNextMonthBtn() {
      const { namefirme } = this.currentPaymentSenderRowSelected;
      const { datebank } = this.currentInetPayNotConnectedPaymentsRowSelected;

      const currentDateBank = this.$moment(datebank, "DD.MM.YYYY").format(
        "MMMM YYYY"
      );
      const futureDateBank = this.$moment(datebank, "DD.MM.YYYY")
        .add(1, "months")
        .format("MMMM YYYY");

      this.$confirm(
        `${this.$t(
          "controlinetpays.moveToNextMonth.confirm.transferPaymentsFrom"
        )} ${namefirme} ${this.$t(
          "controlinetpays.moveToNextMonth.confirm.for"
        )} ${capitalizeFirstLetter(currentDateBank)} ${this.$t(
          "controlinetpays.moveToNextMonth.confirm.on"
        )} ${capitalizeFirstLetter(futureDateBank)}?`,
        this.$t("controlinetpays.moveToNextMonth.confirm.title"),
        {
          confirmButtonText: this.$t("common.buttons.confirmYes"),
          cancelButtonText: this.$t("common.buttons.confirmNo"),
          cancelButtonClass: "cancel-button",
          type: "info"
        }
      )
        .then(() => {
          const { npack } = this.currentInetPayNotConnectedPaymentsRowSelected;
          this.$store.commit("setControlInetPaysReloadAllGrids", false);
          this.$store.dispatch("moveToNextMonth", { npack });
        })
        .catch(() => {});
    },
    onCancelReceivedRegistryBtn() {
      const { namefirme } = this.currentPaymentSenderRowSelected;
      const {
        datebank,
        transferid
      } = this.currentInetPayNotConnectedPaymentsRowSelected;

      const currentDateBank = this.$moment(datebank, "DD.MM.YYYY").format(
        "MMMM YYYY"
      );

      this.$confirm(
        `${this.$t(
          "controlinetpays.cancelReceivedRegistry.confirm.сancelRegistry"
        )} №${transferid} ${this.$t(
          "controlinetpays.cancelReceivedRegistry.confirm.from"
        )} ${namefirme} ${this.$t(
          "controlinetpays.cancelReceivedRegistry.confirm.behind"
        )} ${capitalizeFirstLetter(currentDateBank)}?`,
        this.$t("controlinetpays.cancelReceivedRegistry.confirm.title"),
        {
          confirmButtonText: this.$t("common.buttons.confirmYes"),
          cancelButtonText: this.$t("common.buttons.confirmNo"),
          cancelButtonClass: "cancel-button",
          type: "info"
        }
      )
        .then(() => {
          this.$store.commit("setControlInetPaysReloadUpDownGrids", false);
          this.$store.dispatch("cancelReceivedRegistry", { transferid });
        })
        .catch(() => {});
    },
    onCancelSubscriberPaymentBtn() {
      const {
        fio,
        datepay,
        summpay,
        paymentid
      } = this.currentPersonalAccountsPaymentsRowSelected;

      this.$confirm(
        `${this.$t(
          "controlinetpays.cancelSubscriberPayment.confirm.title"
        )} ${fio} ${this.$t(
          "controlinetpays.cancelSubscriberPayment.confirm.behind"
        )} ${datepay} ${this.$t(
          "controlinetpays.cancelSubscriberPayment.confirm.on"
        )} ${summpay} ${this.params.goptions.monetary_unit}?`,
        this.$t("controlinetpays.cancelSubscriberPayment.confirm.title"),
        {
          confirmButtonText: this.$t("common.buttons.confirmYes"),
          cancelButtonText: this.$t("common.buttons.confirmNo"),
          cancelButtonClass: "cancel-button",
          type: "info"
        }
      )
        .then(() => {
          this.$store.commit("setControlInetPaysReloadUpDownGrids", false);
          this.$store.dispatch("cancelSubscriberPayment", { paymentid });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-container-left {
  margin-top: 0px;
  height: calc(33vh - 28px);
  overflow-y: auto;
}

.grid-container-right-fullheight {
  margin-top: 0px;
  height: calc(100vh - 133px);
  overflow-y: auto;
}

.grid-container-right-halfheight {
  margin-top: 0px;
  height: calc(50vh - 67px);
  overflow-y: auto;
}

.radio-vertical-block {
  display: block;
}

.el-radio__label,
.el-checkbox__label {
  color: #000;
  font-size: 0.9em;
}

.my-card-cont {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  height: calc(100% - 2px);
  font-family: "Open Sans", sans-serif;
  border: 1px solid var(--off-background-color-dark);
  border-radius: 0px;
}

.my-card-box {
  margin: 5px;
  padding: 5px;
  flex: 0 1 auto;
}

.my-card-box:nth-child(1) {
  margin: 0;
  border-bottom: 1px solid var(--off-background-color-dark);
  background-color: var(--off-background-color);
  text-align: center;
  color: black;
  font-weight: 500;
  font-family: "Open Sans Semibold", sans-serif;
  letter-spacing: 0.05em;
  font-size: 0.9em;
  padding: 7px 0px;
}
.my-card-box:nth-child(2) {
  margin: 0;
  flex: 0 1 100px;
}
.my-card-box:nth-child(3) {
  margin: 0;
  border-top: 1px solid #bdc3c7;
  padding: 7px 7px;
}

.el-form-item {
  margin-bottom: 7px;
}

.el-card__header {
  padding: 10px 20px;
}

.el-dialog__body {
  padding: 20px 20px;
}
</style>
